export default __webpack_public_path__ + "static/header.wko.uebersicht-8aa380253ea9827a3b6d3023b47a1797.png";